export default function splitPintListText(initialText) {
	const parts = initialText.split(',');

	if (typeof parts === 'undefined' || parts.length === 0) {
		return;
	}

	const firstThree = parts.slice(0, 3);

	const result = firstThree.join(',');
	return result;
}

export function countLength(initialText) {
	const parts = initialText.split(',');

	if (typeof parts === 'undefined' || parts.length === 0) {
		return;
	}

	const countArrayLength = parts.length;

	return countArrayLength;
}
